module.exports = __webpack_public_path__ + "static/figurine_of_wondrous_power_onyx_dog-927bdb6e54b2cb0ae5a7330c859e39c2.jpg";